import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ee2d861"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Inner relative inline-grid h-full *:row-start-1 *:col-start-1" };
const _hoisted_2 = { class: "Child relative flex items-center gap-8" };
const _hoisted_3 = { class: "Label relative text-desktop-cap" };
import { onBeforeMount, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIBtn',
    props: {
        as: { default: "button" },
        icon: {},
        hover: { type: Boolean },
        active: { type: Boolean },
        theme: { default: "dark" },
        variant: { default: "default" },
        appear: { type: Boolean, default: true },
        sound: { type: [String, Boolean], default: "UI_CLICK" }
    },
    setup(__props) {
        const props = __props;
        const nbChild = ref(1);
        onBeforeMount(() => {
            nbChild.value = 2;
        });
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                duration: { enter: 1250, leave: _ctx.variant === 'solid' ? 500 : 0 },
                appear: _ctx.appear && !_ctx.$attrs.disabled
            }, {
                default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), {
                        type: _ctx.$attrs.type || (_ctx.as === 'button' ? 'button' : undefined),
                        class: _normalizeClass(["UIBtn inline-block relative h-20 whitespace-nowrap focus:outline-none disabled:opacity-40 disabled:pointer-events-none", [`UIBtn--${_ctx.variant}`, { hover: _ctx.hover, active: _ctx.active }]]),
                        "data-theme": _ctx.theme
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nbChild.value, (n) => {
                                    return (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                        _createElementVNode("span", _hoisted_3, [
                                            _renderSlot(_ctx.$slots, "default")
                                        ]),
                                        (_ctx.icon)
                                            ? (_openBlock(), _createBlock(_component_UIIcon, {
                                                key: 0,
                                                name: _ctx.icon,
                                                class: "Icon relative text-16"
                                            }, null, 8, ["name"]))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 256))
                            ])
                        ]),
                        _: 3
                    }, 8, ["type", "class", "data-theme"])), [
                        [
                            _directive_cursor,
                            void 0,
                            void 0,
                            { hover: true }
                        ],
                        [
                            _directive_sound,
                            _ctx.sound,
                            void 0,
                            {
                                hover: true,
                                click: true
                            }
                        ]
                    ])
                ]),
                _: 3
            }, 8, ["duration", "appear"]));
        };
    }
});
